<template>
  <div class="wrap head">
    <div class="wrapContent">
      <div class="left">
        <div>
          <img src="@/assets/image/logo.png" alt="" @click="()=> $router.push({ name: 'Riches' })"></div>
        <p v-show="mainTitle != ''">{{mainTitle}}</p>
      </div>
      <div class="right" v-if="!!site['hot_phone']">
        {{pc_lang.Hotline}}： {{ site['hot_phone']['excel_url'] }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PayHeader',
  props: {
    mainTitle: {
      type: String,
      default: ()=> ''
    }
  },
  data(){
    return {

    }
  },
  computed: {
    ...mapGetters(['site']),
  },
  async mounted() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.wrap{
  background: #fff;
  padding: 4px 0;
  @extend .shadow;
  .wrapContent{
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    .left{
      display: flex;
      align-items: center;
      div{
        img{
          vertical-align: text-bottom;
          max-height: 80px;
        }
      }
      p{
        font-size: 24px;
        color: #555;
        margin-left: 30px;
        position: relative;
        &:before{
          content: '';
          position: absolute;
          left: -16px;
          top: -4px;
          width: 1px;
          height: 40px;
          background: #555;
        }
      }
    }
    .right{
      color: #555;
    }
  }
}
</style>